<template>
  <div
    class="relative bg-gradient-to-br from-white to-slate-50/30 border border-gray-200 rounded-2xl px-6 py-4 cursor-pointer transition-all duration-300 hover:border-primary-300 hover:shadow-2xl hover:-translate-y-1 group overflow-hidden"
    @click="$emit('select', exam)"
  >

    <div class="absolute -top-8 -right-8 w-24 h-24 opacity-5 group-hover:opacity-10 transition-opacity duration-500">
      <div class="w-full h-full bg-gradient-to-br from-emerald-400 to-blue-500 rounded-2xl transform rotate-45"></div>
    </div>

    <div class="relative z-10">
      <div class="flex items-start justify-between mb-5">
        <div class="flex-1 pr-4">
          <div class="mb-3">
            <h3 class="text-xl font-bold text-gray-900 group-hover:text-primary-600 transition-colors duration-300 leading-tight">
              {{ exam.name }}
            </h3>
            <div class="w-0 h-0.5 bg-gradient-to-r from-primary-400 to-primary-500 group-hover:w-20 transition-all duration-700 mt-1"></div>
          </div>

          <div class="inline-flex items-center space-x-2 bg-gradient-to-r from-primary-50 to-primary-50 group-hover:from-primary-100 group-hover:to-primary-100 pl-2 pr-4 py-2 rounded-xl transition-all duration-300 group-hover:scale-105">
            <div class="w-6 h-6 bg-gradient-to-br from-primary-400 to-primary-500 rounded-lg flex items-center justify-center group-hover:rotate-12 transition-transform duration-300">
              <i class="text-white text-xs fa-solid" :class="getExamTypeClass(exam.type)"></i>
            </div>
            <span class="text-sm font-semibold text-primary-700 group-hover:text-primary-800 transition-colors">
              {{ getExamTypeLabel(exam.type) }}
            </span>
          </div>
        </div>

        <div class="w-12 h-12 bg-gray-100 group-hover:bg-gradient-to-br group-hover:from-primary-100 group-hover:to-primary-100 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-12">
          <i class="fa-solid fa-arrow-right text-gray-400 group-hover:text-emerald-500 group-hover:translate-x-1 transition-all duration-300"></i>
        </div>
      </div>

      <div v-if="exam.description" class="relative">
        <div class="absolute -left-2 top-1 w-1 h-4 bg-gradient-to-b from-primary-400 to-primary-500 rounded-full opacity-50 group-hover:opacity-100 transition-opacity duration-300"></div>

        <p class="text-gray-600 text-sm leading-relaxed line-clamp-3 group-hover:text-gray-700 transition-colors duration-300 pl-4">
          {{ exam.description }}
        </p>
      </div>

      <div class="mt-5 flex items-center justify-between">


        <!-- Indicateur de difficulté (si disponible) -->
        <div v-if="exam.difficulty" class="flex items-center space-x-1">
          <template v-for="i in 5" :key="i">
            <div
              class="w-2 h-2 rounded-full transition-colors duration-300"
              :class="i <= exam.difficulty
                ? 'bg-gradient-to-r from-yellow-400 to-orange-500'
                : 'bg-gray-200 group-hover:bg-gray-300'"
            ></div>
          </template>
        </div>

        <div v-else-if="exam.isFavorite" class="text-yellow-500 group-hover:text-yellow-600 transition-colors">
          <i class="fa-solid fa-star text-sm"></i>
        </div>
      </div>
    </div>

    <div class="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -skew-x-12 transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out"></div>

    <div class="absolute bottom-2 right-2 opacity-0 group-hover:opacity-30 transition-opacity duration-500">
      <div class="flex space-x-1">
        <div class="w-1 h-1 bg-primary-500 rounded-full animate-bounce" style="animation-delay: 0ms;"></div>
        <div class="w-1 h-1 bg-primary-300 rounded-full animate-bounce" style="animation-delay: 150ms;"></div>
        <div class="w-1 h-1 bg-primary-100 rounded-full animate-bounce" style="animation-delay: 300ms;"></div>
      </div>
    </div>
  </div>
</template>



<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  exam: {
    type: Object,
    required: true
  }
})

defineEmits(['select'])

const getExamTypeClass = (type) => {
  const classes = {
    'READING': 'fa-book-open',
    'LISTENING': 'fa-headphones',
    'WRITING': 'fa-signature',
    'SPEAKING': 'fa-user-ninja'
  }
  return classes[type] || 'bg-gray-100 text-gray-800'
}

const getExamTypeLabel = (type) => {
  const labels = {
    'READING': 'Lecture',
    'LISTENING': 'Écoute',
    'WRITING': 'Écriture',
    'SPEAKING': 'Expression orale'
  }
  return labels[type] || type
}
</script>

<style scoped>
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
